//====================================================
//  Function: Map
//====================================================
function fn_components_map(){
    $('.map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        var langitude = inst.data('langitude');
        var longitude = inst.data('longitude');
        fn_init_map(id, langitude, longitude);
    });


}

function fn_init_map(id, langitude, longitude){
    var map;
    var mapOptions = {
        center: new google.maps.LatLng(langitude,longitude),
        zoom: 17,
        zoomControl: true,
        disableDoubleClickZoom: false,
        mapTypeControl: true,
        scaleControl: true,
        scrollwheel: false,
        panControl: true,
        streetViewControl: true,
        draggable : true,
        overviewMapControl: false,
        overviewMapControlOptions: {
            opened: false,
        },
        styles: [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.station.bus",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#cfe5ef"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ],
        mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    var mapElement = document.getElementById(id);
    var map = new google.maps.Map(mapElement, mapOptions);
    var imageSrc = "images/marker.png";
    var locations = [
        [ langitude,  longitude]
    ];

    var markerImage = new google.maps.MarkerImage(
        imageSrc,
         null,
         // The origin for my image is 0,0.
         new google.maps.Point(0, 0),
         // The center of the image is 50,50 (my image is a circle with 100,100)
         new google.maps.Point(19, 59)
     );

    for (i = 0; i < locations.length; i++) {
        marker = new google.maps.Marker({
            icon: markerImage,
            position: new google.maps.LatLng(locations[i][0], locations[i][1]),
            map: map
        });
    link = '';     
    }
}